import instance from "../http";
import { getHeader } from "../../utils/utils";
import { profileManagement } from "../../constants/path";

export async function getProfileDataAPI(project_uuid) {
    const headers = getHeader();
    const response = await instance.get(profileManagement.GET_PROFILE + project_uuid, headers);
    return response;
}

export async function manageProfileAPI(_profileData) {
    const headers = getHeader()
    const response = await instance.put(
        profileManagement.MANAGE_PROFILE,
        _profileData,
        headers
    );
    return response;
}

export async function changePasswordAPI(_password) {
    const headers = getHeader();
    const response = await instance.patch(profileManagement.CHANGE_PASSWORD, _password, headers);
    return response;
}
